module.exports = __webpack_public_path__ + "static/img/sjmb.845e2bcd.jpg";